import { useState } from 'react';

import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useAddressInput = () => {
    const [showDetailedForm, setShowDetailedForm] = useState(false);
    const [showAddressSuggestions, setShowAddressSuggestions] = useState(false);
    const [showDetailedFormOnNoInput, setShowDetailedFormOnNoInput] =
        useState(true);

    return {
        showDetailedForm,
        setShowDetailedForm,
        showAddressSuggestions,
        setShowAddressSuggestions,
        showDetailedFormOnNoInput,
        setShowDetailedFormOnNoInput,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useAddressInput();

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [AddressInputProvider, useAddressInputContext] =
    createContextProvider(providerFactory);
